module.exports = __webpack_public_path__ + "img/ico_position_footer_on.a01dc9cd.svg";